export default [
  {
    label: 'Razão social', field: 'razaoSocial', editable: true, evento: null,
  },
  { label: 'CNPJ/CPF', field: 'cadastroFederal', tdClass: 'col-tamanho-cnpj' },
  { label: 'Inscrição estadual', field: 'inscricaoEstadual' },
  { label: 'Município/UF', field: 'municipioUf' },
  { label: 'Regime', field: 'empresaRegime' },
  { label: 'Certificado digital', field: 'certificadoVinculado', type: 'custom' }]
